import React, { Component } from 'react';
import { Button, Form, Image } from 'semantic-ui-react'
import { ref, firebaseAuth, logComponentLoad } from '../../../config/constants';
import ImageUploader from '../ImageUploader'
import Select from 'react-select';
import { checkAdminEmail, getPrintValues } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getShirtTypesToDisplay, getColors } from '../../dashBoard/newDashboard/LargeProjects/ApiUtils'


class ImageFnder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image_tags: '',
            imageUrl: 'none',
            algoliaUser: '',
            colors: [],
            // colors: [
            //     { value: 'black', label: 'black', category: 'shirtColor' },
            // ],
            printTypes: [
                // { value: 'puff', label: 'puff' , category: 'printType' },
            ]
        }
    }

    componentDidMount() {
        //  getPrintValues("shirtType", this.setItemTypes);

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    checkAdminEmail(user.email, this.setAdminResult)

                    getPrintValues("printType", this.setPrintTypes);
                    getShirtTypesToDisplay(this.setShirtTypeDropDown, "imageSearch");
                    getColors(this.setShirtColorsDropDown);

                    //CHECK ALGOLIA FOR USER

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ImageFnder");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    setShirtColorsDropDown = (shirtColors) => {
        // console.log("gcltx3 +++++++:setShirtColorsDropDown");
        // console.log("gcltx31:" + JSON.stringify(shirtColors, null, 3));
        this.setState({
            loading: false,
            colors: shirtColors
        })
    }

    setShirtTypeDropDown = (shirtTypes) => {
        // console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false,
            shirtTypeChoices: shirtTypes
        })
    }

    setPrintTypes = (printTypes) => {
        // console.log("prnt1 +++++++++++:setPrintTypes");
        // console.log("prnt12 setPrintTypes:" + printTypes.length);
        // console.log("prnt13:" + JSON.stringify(printTypes, null, 3));

        this.setState({
            printTypes: printTypes
        })

    }

    // GET VALUE FROM ALGOLIA AS CALL BACK AND SET THEM TO STATE
    // setItemTypes = (itemTypes) => {
    //     console.log("algx1 +++++++++++:setItemTypes");
    //     console.log("algx1 itemTypes:" + itemTypes.length);

    //     this.setState({
    //         shirtTypeChoices: itemTypes
    //     })

    // }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        // console.log("hx32 e.target.name:" + e.target.name);
        // console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    saveTags = () => {
        console.log("IMAGE FINDER: ++++++saveTags");

        let newPostKey = ref.child('imageFinder').push().key;
        console.log("ssi02 newPostKey:" + newPostKey);

        let tagObject = {
            tags: this.state.image_tags,
            shirtType: this.state.shirtType,
            shirtColor: this.state.shirtColor,
            printType: this.state.printType,
            imageUrl: this.state.imageUrl,
            actualFileName: this.state.actualFileName
        }

        ref.child('imageFinder/' + newPostKey).set(tagObject);
    }

    /**
  * UPDATE STATE WHEN FILE UPLOAD IS COMPLETE
  */
    updateWhenFileUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++:updateWhenFileUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url
        });
        // this.props.history.push('/newOrder/thankYou');

    }

    handleDropDownChanges = (value) => {
        console.log("gshtx4 +++  handleDropDownChanges");
        console.log('gshtx41 You\'ve sss:', value);
        console.log('gshtx42 You\'ve selected:', value.value + " " + value.category);


        //FOR SHIRT TYPES ONLY...
        if (value.category == 'shirtTypeId') {
            console.log("gshtx43 category is shirtTypeId setting shirtType to:" + value.label);

            this.setState({
                shirtType: value.label
            })

        }
        // } else {
        console.log("gshtx43 category is NOT shirtTypeId");
        //this.setState(newState);
        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);

    }

    render() {

        /**
     * SHOWS IMAGE PREVIEW OF WHAT'S BEEN UPLOADED
     */
        const imagePreview = this.state.imageUrl != 'none'
            ? (<Image src={this.state.imageUrl} fluid />)
            : (<p></p>)

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.isAdmin && this.state.algoliaUser.imageFnder
            ? <div>
                <Form onSubmit={this.saveTags}>
                    <Form.Field>
                        <label>up load image to be searched {this.state.shirtType} </label>
                        <Form.TextArea
                            name={'image_tags'}
                            value={this.state.pricing_notes}
                            placeholder='Tags:'
                            onChange={this.handleTextInputChange}
                        />
                    </Form.Field>

                    <Select
                        name="form-field-name"
                        // value={this.state.shirtType}
                        value={this.state.shirtTypeId}
                        options={this.state.shirtTypeChoices}
                        onChange={this.handleDropDownChanges}
                        searchable={true}
                        clearable={false}
                    />
                    <br />
                    <Select
                        name="form-field-name"
                        value={this.state.shirtColor}
                        options={this.state.colors}
                        onChange={this.handleDropDownChanges}
                        searchable={true}
                        clearable={false}
                    />


                    <br />
                    <Select
                        name="form-field-name"
                        value={this.state.printType}
                        options={this.state.printTypes}
                        onChange={this.handleDropDownChanges}
                        searchable={true}
                        clearable={false}
                    />

                    <ImageUploader
                        updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                        storageReference={'imageNotes'} />
                    {imagePreview}

                    <Button type='submit'>Submit</Button>
                </Form>
            </div>
            : <h4>loading error a75</h4>

        return (
            <div>
                {wholeUI}
                

            </div>)
    }
}

export default ImageFnder;


// WEBPACK FOOTER //
// ./src/components/newSite/ImageFinder/ImageFinder.js